import React, { useRef } from 'react';
import Button from '@mui/material/Button';
import { getFormattedDate, getRoomLabelText } from '@src/utilities/common';
import { useReactToPrint } from 'react-to-print';
import PrintIcon from '@mui/icons-material/Print';
import { printToKOTPrinter } from './PrintUtility';
import './Print.scss';
// import { stringify } from 'querystring';

declare global {
    interface Window {
        ReactNativeWebView: any;
    }
}
interface componentRef {
    current: any
}

function PrintRoomKOT({ item }: any) {
    const componentRef: componentRef = useRef(null);
    // Create a root reference
    // const firebaseApp = getApp();
    // const storage = getStorage(firebaseApp, "gs://iit-nirvana.appspot.com");
    // const storageRef = ref(storage, `order-pdf/${item?.orderId}.pdf` || 'order-pdf/order-pdf.pdf');

    const handlePrint = useReactToPrint({
        content: () => componentRef?.current,
    });

    const _sendMessageToWebView = (urlPdf: any) => {
        const data = {"type": "print", "data": urlPdf || "https://www.adobe.com/support/products/enterprise/knowledgecenter/media/c4611_sample_explain.pdf"};
        // console.log(data, componentRef?.current?.innerHTML);
        if(window?.ReactNativeWebView){
            // const data = 'Hello from React!';
            window.ReactNativeWebView.postMessage(JSON.stringify(data) || "");
        } else {
            handlePrint();
        }
    };

    const getHTMLString = (item: any) => {
        var sum = "";
        (!!(item?.rooms) && item?.rooms)?.forEach((room: any) => {
            sum += (!!room && `<tr>
                <td style="text-align: left;">
                    ${(room?.roomType)} (${getRoomLabelText(room?.roomNumber?.split("-")[0], parseInt(room?.roomNumber?.split("-")[1]))})
                </td>
                <td style="width: 50px; text-align: right;">
                ${room?.roomCustomCost} x ${room?.noOfNights}
                </td>
                <td style="width: 35px; text-align: right;">
                    ${room?.roomCustomCost * room?.noOfNights}
                </td>
            </tr>`) || ''
        });
        return `
            <div style="font-size: 12px; width: 190px; color: #000;">
                <p style="font-size: 13px; text-align: center; font-weight: bold; margin: 0;">${item?.restaurant?.name}</p>
                ${(!!item?.isGstBill &&  `<p style="text-align: center; margin: 0;">GSTIN: ${item?.restaurant?.gstIn}</p>`) || ""}
                <p style="font-size: 11px; text-align: center; margin: 0;">${item?.restaurant?.address}</p>
                <p style="text-align: center; margin: 0;">Order#: ${item?.orderSeqNo || item?.uoId || item?.orderId}</p>
                <p style="text-align: right; margin: 0;">Phone#: ${item?.user?.phoneNumber}</p>
                <p style="text-align: right; margin: 0;">${getFormattedDate(item?.createdAt)}</p>
                <p style="text-align: left; margin: 0;"><b>Guest Details</b></p>
                <p style="text-align: right; margin: 0;">${item?.guestName}</p>
                <p style="text-align: left; margin: 0;"><b>Address:</b></p>
                <p style="text-align: right; margin: 0; padding-left: 10px;">${item?.guestAddress}</p>
                <p style="text-align: left; margin: 0;"><b>Other:</b></p>
                <p style="text-align: right; margin: 0; padding-left: 10px;">${item?.guestOther}</p>
                <p style="text-align: left; margin: 0;"><b>Extra Info:</b></p>
                <p style="text-align: right; margin: 0; padding-left: 10px;">${item?.guestExtraInfo}</p>
                <p style="text-align: left; margin: 0;"><b>Company Name:</b></p>
                <p style="text-align: right; margin: 0; padding-left: 10px;">${item?.guestCompanyName}</p>
                <p style="text-align: left; margin: 0;"><b>Company GST:</b></p>
                <p style="text-align: right; margin: 0; padding-left: 10px;">${item?.guestCompanyGST}</p>
                <p style="text-align: left; margin: 0;"><b>Check-in Date:</b></p>
                <p style="text-align: right; margin: 0; padding-left: 10px;">${getFormattedDate(item?.checkInDate)}</p>
                <p style="text-align: left; margin: 0;"><b>Check-out Date:</b></p>
                <p style="text-align: right; margin: 0; padding-left: 10px;">${getFormattedDate(item?.checkOutDate)}</p>
                <table style="font-size: 11px; width: 190px; border-top: 1px solid #666; text-transform: capitalize;">
                </table>
                <p style="text-align: center; margin: 0;"><b>Room Booking Details</b></p>
                <table style="font-size: 11px; width: 190px; border-bottom: 1px solid #666; text-transform: capitalize;">
                    ${sum || ''}
                </table>
                <table style="font-size: 13px; width: 190px;">
                    ${(!!item?.itemsCost && `<tr>
                        <td style="text-align: right;">Rooms Cost :</td>
                        <td style="width: 95px; text-align: right;">Rs.${item?.itemsCost}</td>
                    </tr>`) || ''}
                    ${(!!item?.isGstBill && `<tr>
                        <td style="text-align: right;">GST(${item?.restaurant?.roomGST}%) :</td>
                        <td style="width: 95px; text-align: right;">Rs.${item?.gstBill}</td>
                    </tr>`) || ''}
                    ${(!!item?.discount && `<tr>
                        <td style="text-align: right;">Discount :</td>
                        <td style="width: 95px; text-align: right;">Rs.${item?.discount}</td>
                    </tr>`) || ''}
                    <tr>
                        <td style="font-weight: bold; text-align: right;">Total Room Bill :</td>
                        <td style="font-weight: bold; text-align: right;width: 95px;">Rs.${item?.totalCost}</td>
                    </tr>
                </table>
            </div>
        `;
    }

    const handleGeneratePdf = async (e: any) => {
        e.stopPropagation();
        const htmlContent = await getHTMLString(item);
        // await printPDF(htmlContent, item?.uoId || item?.orderId);
        await printToKOTPrinter("main", htmlContent, item?.uoId || item?.orderId);
        // if(window?.ReactNativeWebView){
        //     printOnNative(item);
        // } else {
        //     handlePrint();
        // }
    };

    return (
        <>
            <Button color='secondary' className='printBtn' onClick={(e: any) => handleGeneratePdf(e)}><PrintIcon /> KOT</Button>
            {/* <div className='hidden'>
                <div ref={componentRef} dangerouslySetInnerHTML={{__html: getHTMLString(item)}}></div>
            </div> */}
        </>
    );
}

export default PrintRoomKOT;
